import { render, staticRenderFns } from "./TicketSystem.vue?vue&type=template&id=5ab24a32&scoped=true"
import script from "./TicketSystem.vue?vue&type=script&lang=js"
export * from "./TicketSystem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ab24a32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ab24a32')) {
      api.createRecord('5ab24a32', component.options)
    } else {
      api.reload('5ab24a32', component.options)
    }
    module.hot.accept("./TicketSystem.vue?vue&type=template&id=5ab24a32&scoped=true", function () {
      api.rerender('5ab24a32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/users/TicketSystem.vue"
export default component.exports